import React from 'react';
import clsx from 'clsx';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Style from '../Styles/LeftMenuDrawerStyle';
import MenuIcon from '@mui/icons-material/Menu';
import ViewListIcon from '@mui/icons-material/ViewList';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import Divider from '@mui/material/Divider';
import Settings from '../../../Settings/Settings';
import {
    Link
  } from "react-router-dom";

export default function LeftMenuDrawer(props) {
  const classes = Style();
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

    const componentConstants = {
        ...props.componentConstants
    }

    const componentMethods = {
        ...props.componentMethods
    }

  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === 'top' || anchor === 'bottom',
      })}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        {componentMethods.hasAccess(Settings.SETTING_ACCESS_LEVEL_ORDER_PROCESSER) ?
          <React.Fragment>
            <Link to="/orders" style={classes.link}>
              <ListItem>
                   
                        <ListItemIcon><ViewListIcon /></ListItemIcon>
                        <ListItemText primary={componentConstants.language.LANG_ORDERS}/>
              </ListItem>
            </Link>
            <Divider />
          </React.Fragment>
          :
          null
          }
          {componentMethods.hasAccess(Settings.SETTING_ACCESS_LEVEL_ORDER_PROCESSER) ?
          <React.Fragment>
            <Link to="/compatible/products" style={classes.link}>
              <ListItem>
                   
                        <ListItemIcon><AccountTreeIcon /></ListItemIcon>
                        <ListItemText primary={componentConstants.language.LANG_COMPATIBLE_PRODUCTS}/>
              </ListItem>
            </Link>
            <Divider />
          </React.Fragment>
          :
          null
          }
      </List>
    </div>
  );

  return (<React.Fragment>
    {componentMethods.hasAccess(Settings.SETTING_ACCESS_LEVEL_ORDER_PROCESSER) ?
    <div>
      {['left'].map((anchor) => (
        <React.Fragment key={anchor}>
            <IconButton color="secondary" onClick={toggleDrawer(anchor, true)}>
              <MenuIcon />
            </IconButton>
            <Drawer anchor={anchor} open={state[anchor]} onClose={toggleDrawer(anchor, false)}>
              {list(anchor)}
            </Drawer>
        </React.Fragment>
      ))}
    </div>
    : 
      null
    }
    </React.Fragment>
  );
}